import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
export const BtnXuatDanhSach = () => {
  const dataSearch = useSelector((state) => state.dataSearchDanhSachThanhLy); //dataSearchTaiSan dinh nghia o rootreducer
  const xuatExcel = () => () => {
    let { customerName, taisanCode, hopdongCode, tuNgay, denNgay } = dataSearch;

    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }

    link = link +
      `quan-ly-tai-san/danh-sach-thanh-ly-xuat-excel?customerName=${customerName}&taisanCode=${taisanCode}&hopdongCode=${hopdongCode}&tuNgay=${tuNgay}&denNgay=${denNgay}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "DanhSachThanhLy.xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };
  return (
    <>
      <a
        href={() => false}
        className="icon-bgnew color-print1"
        onClick={xuatExcel()}
      >
        <PopoversBootrap
          contentText="Xuất danh sách"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
             <img src="/app-assets/images/icon-tai-xuong-v2.png" />
        </PopoversBootrap>
      </a>
    </>
  );
};
